import { markRaw } from 'vue';
import PurchaseTableItem from '@/components/elements/PurchaseTableItem';
import HistoryTableItem from '@/components/elements/HistoryTableItem';
import OrganizationsTableItem from '@/components/elements/OrganizationsTableItem';
import UsersTableItem from '@/components/elements/UsersTableItem';
import ObjectsTableItem from '@/components/elements/ObjectsTableItem';
import ContractListTableItem from '@/components/blocks/contract/ContractListTableItem';
import ProtocolListTableItem from '@/components/blocks/protocols/ProtocolListTableItem';
import SupplyRequestListTableItem from '@/components/blocks/supply-request/SupplyRequestListTableItem';
import SupplyTaskListTableItem from '@/components/blocks/supply-task/SupplyTaskListTableItem';
import SupplyTaskDetailsTable from '@/components/blocks/supply-task/SupplyTaskDetailsTable';
import ClarificationListTableItem from '@/components/blocks/clarifications/ClarificationListTableItem';
import NotificationListTableItem from '@/components/blocks/notifications/NotificationListTableItem';
import GenContractorTableItem from '@/components/elements/GenContractorTableItem.vue';
import GenContractorLotTableItem from '@/components/elements/GenContractorLotTableItem.vue';
import ContractWorkTableItem from '@/components/elements/ContractWorkTableItem.vue';
import TableItem from '@/components/elements/documents/TableItem.vue';

export const PAGE_TYPES_DATA = {
  LOTS: {
    head: <tr>
            <th>Номер извещения</th>
            <th>Дата публикации</th>
            <th>Окончание подачи заявки</th>
            <th>Наименование закупки</th>
            <th>Регион поставки</th>
            <th class="thead-th--rigth">НМЦ</th>
            <th>Статус</th>
            <th></th>
          </tr>,
    row: markRaw(PurchaseTableItem),
    zeroState: 'Пока нет актуальных закупок.',
  },
  DOCUMENTS: {
    head: <tr>
      <th>Дата документа</th>
      <th>Тип документа</th>
      <th>Наименование документа</th>
      <th>Наименование объекта</th>
      <th></th>
    </tr>,
    row: markRaw(TableItem),
    zeroState: 'Пока нет документов.',
  },
  LOTS_FAVORITE: {
    head: <tr>
      <th>Номер извещения</th>
      <th>Дата публикации</th>
      <th>Окончание подачи заявки</th>
      <th>Наименование закупки</th>
      <th>Регион поставки</th>
      <th class="thead-th--rigth">НМЦ</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(PurchaseTableItem),
    zeroState: 'Подходящих закупок не найдено',
  },
  HISTORY: {
    head: <tr>
            <th>Дата внесения изменений</th>
            <th>Наименование</th>
            <th>Старое значение</th>
            <th>Новое значение</th>
          </tr>,
    row: markRaw(HistoryTableItem),
    zeroState: 'Истории не найдено',
  },
  OBJECTS: {
    head: <tr>
            <th class="text-nowrap">Номер объекта</th>
            <th>Наименование объекта</th>
            <th>Адрес объекта</th>
            <th></th>
          </tr>,
    row: markRaw(ObjectsTableItem),
    zeroState: 'Объектов не найдено',
  },
  ORGANIZATIONS: {
    head: <tr>
            <th>Наименование организации</th>
            <th class="thead-th--rigth">ИНН</th>
            <th>Статус</th>
            <th></th>
            <th></th>
          </tr>,
    row: markRaw(OrganizationsTableItem),
    zeroState: 'Организаций не найдено',
  },
  GENERAL_CONTRACTORS: {
    head: <tr>
      <th>Наименование организации</th>
      <th class="thead-th--rigth">ИНН</th>
      <th class="thead-th--rigth">ОГРН</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(GenContractorTableItem),
    zeroState: 'Организаций не найдено',
  },
  GEN_CONTRACTOR_LOTS_LIST: {
    head: <tr>
      <th>Номер конкурса</th>
      <th>Дата и время начала торгов</th>
      <th>Дата и время окончания торгов</th>
      <th>Наименование конкурса</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(GenContractorLotTableItem), // @todo
    zeroState: 'Актуальных конкурсов на генподряд не найдено',
  },
  CONTRACT_WORK_LIST: {
    head: <tr>
      <th>Номер конкурса</th>
      <th>Дата публикации</th>
      <th>Тип конкурса</th>
      <th>Наименование конкурса</th>
      <th>Дата и место проведения торгов по очному конкурсу</th>
      <th>Даты проведения торгов по онлайн-конкурсу</th>
      <th>Регион</th>
      <th>Объект</th>
      <th>Проект</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(ContractWorkTableItem),
    zeroState: 'Конкурсы на подряд не найдены',
  },
  ORGANIZATION_DETAILS: {
    head: <tr>
            <th class="text-nowrap">ID пользователя</th>
            <th>ФИО пользователя</th>
            <th>Email</th>
            <th class="text-nowrap">Тип участника</th>
            <th>Статус</th>
            <th></th>
          </tr>,
    row: markRaw(UsersTableItem),
    zeroState: 'Пользователей не найдено',
  },
  CONTRACTS: {
    head: <tr>
      <th>Дата</th>
      <th>Наименование</th>
      <th>Номер</th>
      <th>Объект</th>
      <th>Регион</th>
      <th>Контрагент</th>
      <th></th>
    </tr>,
    row: markRaw(ContractListTableItem),
    zeroState: 'Договора не найдены',
  },
  PROTOCOLS: {
    head: <tr>
      <th>Номер извещения</th>
      <th>Наименование закупки</th>
      <th>Номер протокола</th>
      <th>Дата протокола</th>
      <th>Наименование объект</th>
      <th>Контрагент</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(ProtocolListTableItem),
    zeroState: 'Протоколы не найдены',
  },
  SUPPLYREQUEST: {
    head: <tr>
      <th>Номер заявки</th>
      <th>Дата создания</th>
      <th>Заказчик</th>
      <th>Наименование объекта</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(SupplyRequestListTableItem),
    zeroState: 'Заявки на поставку не найдены',
  },
  SUPPLYTASK: {
    head: <tr>
      <th>Номер задания</th>
      <th>Дата создания</th>
      <th>Договор</th>
      <th>Объект</th>
      <th>Заказчик</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(SupplyTaskListTableItem),
    zeroState: 'Задания на поставку не найдены',
  },
  SUPPLY_REQUEST_DETAILS: {
    head: <tr>
      <th>Номер</th>
      <th>Наименование материала</th>
      <th>Количество</th>
      <th>Ед. изм.</th>
      {/* <th>Цена за ед</th> */}
      {/* <th>Сумма</th> */}
      <th>Дата поставки (крайний срок)</th>
      <th></th>
    </tr>,
    row: markRaw(SupplyTaskDetailsTable),
    zeroState: 'Материалов/оборудования не найдено',
  },
  CLARIFICATIONS: {
    head: <tr>
      <th>Номер запроса</th>
      <th>Дата создания</th>
      <th>Номер лота</th>
      <th>Наименование закупки</th>
      <th>Статус</th>
      <th></th>
    </tr>,
    row: markRaw(ClarificationListTableItem),
    zeroState: 'Запросы на разъяснение не найдены',
  },
  NOTIFICATIONS: {
    head: <tr>
      <th>Дата отправки</th>
      <th>Текст уведомления</th>
      <th></th>
    </tr>,
    row: markRaw(NotificationListTableItem),
    zeroState: 'Уведомления не найдены',
  },
};

// eslint-disable-next-line no-return-assign
export const PAGE_TYPES = { ...PAGE_TYPES_DATA };

Object.keys(PAGE_TYPES).forEach((key) => {
  PAGE_TYPES[key] = key;
});
